// src/features/live/panels/LiveCategoriesPanel.tsx — right-rail category
// shortcuts. Mirrors src/features/videos/panels/VideoCategoriesPanel.tsx: each
// link genuinely navigates to the filtered view (?chip=<category>), read by
// LivePage the same way VideosPage seeds its chip from ?chip=.
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Panel, SectionLabel } from '@/ui';
import { WEB_CHIPS } from '../meta';

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const CategoryLink = styled(Link)`
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: 600;
  color: ${({ theme }) => theme.color.textPrimary};
  text-decoration: none;
  &:hover { color: ${({ theme }) => theme.color.accentCyan}; }
`;

const CATEGORIES = WEB_CHIPS.filter((c) => c.id !== 'all');

export function LiveCategoriesPanel() {
  return (
    <Panel>
      <SectionLabel as="h2">Categories</SectionLabel>
      <List>
        {CATEGORIES.map((c) => (
          <li key={c.id}>
            <CategoryLink to={`/live?chip=${c.id}`}>{c.label}</CategoryLink>
          </li>
        ))}
      </List>
    </Panel>
  );
}
